import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'

import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'

class Requalification extends Component {
state = {
    redirect:false,
    search: ''
    }

handleCHange = event => {
    const { name, value } = event.target
    this.setState({ [name]: value })
}

setRedirect = () => {
    this.setState({
      redirect: true
    })
  }
  
  handleSubmitFacebbok = () => {
    if (this.state.redirect) {
        window.location.href = "https://www.facebook.com/clubCAPN/";
    }
  }

handleSubmit = event => {
    //on gere le form
    event.preventDefault()
    this.props.history.push(`/recherche/${this.state.search}`);
}

render () {  
    return (
    <>
        <Container fluid>
        <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <Row>
                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                    <div className="histoire-content">
                        <h1><span>Requalifications </span></h1>   
                        <h2>Premiers Soins Général</h2>
                        <p className="pCenter"> 
                        <strong>Coût:</strong> 65 $<br />
                        <strong>Date de requalification:</strong>
                        Aucune<br /><br />
                        </p>

                        <h2>Premiers Soins Général</h2>
                        <p className="pCenter"> 
                        <strong>Coût:</strong> 95 $<br />
                        <strong>Date de requalification:</strong>
                        Aucune<br /><br />
                        </p>

                        <h2>Sauveteur National intensif</h2>
                        <p className="pCenter"> 
                        <strong>Coût:</strong> 65 $<br />
                        <strong>Date de requalification:</strong>
                        Aucune<br /><br />
                        </p>

                        <h2>Challenge médaille de bronze</h2>
                        <p className="pCenter"> 
                        <strong>Coût:</strong> 100 $<br />
                        <strong>Date de requalification:</strong>
                        Aucune<br /><br />
                        </p>

                        <h2>Challenge croix de bronze</h2>
                        <p className="pCenter"> 
                        <strong>Coût:</strong> 100 $<br />
                        <strong>Date de requalification:</strong>
                        Aucune<br /><br />
                        </p>

                                      
                    </div>

                    </Col>
                    </Row>
                </Col>


            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                <Footer />
            </Col>
            </Col>
        </Row>
        </Container>
    </>
    )
}
}

export default Requalification
